import { FC } from "react";

export const PromptFlagBadge: FC<{ featureFlag: string | null }> = ({ featureFlag }) =>
  featureFlag ? (
    <span
      className="rounded bg-blue-50 px-2 py-0.5 text-[12px] leading-[18px] text-blue-800"
      title={`Used only for organizations with the ${featureFlag} feature flag on`}
    >
      Flag: {featureFlag}
    </span>
  ) : null;
